export const CHATS_MESSAGES_LIMIT = 50;

export function buildGroupParams(search: string, isUnreadFilterEnabled?: boolean) {
	return {
		search: search,
		ordering: 'last_message_time',
		unread: isUnreadFilterEnabled ? 'true' : ''
	};
}
